import React from 'react'
import ReviewItem, { ReadMorePanel, ReviewItemProps } from './ReviewItem'
import styles from './styles.module.scss'
import htmr from 'htmr'
import ScrollCarousel from '@components/ui/ScrollCarousel'

export type ReviewsProps = {
  title: React.ReactNode
  byline?: string
  reviews: {
    [key: number]: ReviewItemProps
  }
  onReadMore?: () => void
}

export default function Reviews({
  title,
  byline,
  reviews,
  onReadMore
}: ReviewsProps) {
  const reviewsList = Object.values(reviews)
  return (
    <>
      {!!reviewsList?.length && (
        <div className={styles.Reviews}>
          <div className={styles.Reviews__wrapper}>
            <div className={styles.Reviews__copy}>
              {!!title && (
                <h2 className={styles.Reviews__title}>
                  {typeof title === 'string' ? htmr(title) : title}
                </h2>
              )}
              {byline && <p>{byline}</p>}
            </div>

            <div className={styles.Reviews__carousel}>
              <ScrollCarousel
                settings={{
                  buttons: {
                    visible: {
                      mobile: false,
                      desktop: true
                    },
                    position: 'bottom'
                  },
                  overflow: true,
                  loop: !onReadMore,
                  align: 'start',
                  progressBar: {
                    visible: {
                      mobile: true,
                      desktop: true
                    }
                  }
                }}
                classes={styles.Reviews__scrollCarousel}
              >
                {reviewsList.map(review => (
                  <ReviewItem
                    key={`review-${review.author}-${review.stars}`}
                    {...review}
                  />
                ))}
                {onReadMore && <ReadMorePanel onClick={onReadMore} />}
              </ScrollCarousel>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
